import cn from 'classnames';
import { ClickableIcon, Header, HStack, type HVStackProps, IconClose } from '@direct-frontend/components';
import { useDialogContext } from './DialogContext';
import styles from './DialogTitle.module.css';

export type DialogTitleProps = Omit<HVStackProps, 'children' | 'gap'> & {
    title: string;
};

export const DialogTitle = (props: DialogTitleProps) => {
    const { className, title, ...other } = props;
    const { isFullscreen, onClose } = useDialogContext();

    return isFullscreen ? (
        <HStack
            {...other}
            gap="16"
            justifyContent="space-between"
            className={cn(className, styles.container, {
                [styles.container__fullscreen]: isFullscreen,
            })}
        >
            <Header level="h3">{title}</Header>
            <ClickableIcon onClick={onClose}>
                <IconClose size="24" />
            </ClickableIcon>
        </HStack>
    ) : null;
};
